import React, { useState } from 'react'
import Container from '../../components/Container'
import Table from '../../components/Table'
import Tabs from '../../components/Tabs'
import { getLeadsAvailable, getLeadsCompleted, getLeadsInWork } from "../../api/Api";

interface NewTodayType {
  service: string,
  type: string,
  howFast: string,
  address: string,
  city: string,
  zip: string,
  name: string,
  phone: string,
  email: string
}

type Available = NewTodayType

interface InWorkType extends NewTodayType {
  bool: boolean
}

type CompletedType = InWorkType

interface DataType {
  newToday: NewTodayType[],
  available: Available[],
  inWork: InWorkType[],
  completed: CompletedType[]
}

export interface FetchDataType<T> {
  [key: string]: T
}

const Leads: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState<DataType>({
    newToday: [],
    available: [],
    inWork: [],
    completed: []
  })

  const columns = {
    service: {
      title: 'Service',
    },
    type: {
      title: 'Service type',
    },
    howFast: {
      title: 'How fast',
    },
    address: {
      title: 'Address',
    },
    city: {
      title: 'City',
    },
    zip: {
      title: 'Zip code',
    },
    name: {
      title: 'Name',
    },
    phone: {
      title: 'Phone',
    },
    email: {
      title: 'E-mail',
    }
  }

  const onClickTab = (name: string) => {
    console.log(name)
    switch (name) {
      case 'newToday':
        return;

      case 'inWork':
        setIsLoading(true)
        getLeadsInWork()
          .then(res => {
            setData({
              ...data, inWork:
                res.data.data.map(<T,>(item: FetchDataType<T>) => ({
                  service: '',
                  type: item.type_of_cleaning,
                  howFast: item.created_at,
                  address: `${item.country}, ${item.city}, ${item.street}`,
                  city: item.city,
                  zip: '',
                  name: item.country,
                  phone: '',
                  email: ''
                })
                )
            })
            setIsLoading(false)
          }).catch(() => setIsLoading(false))
        return;

      case 'completed':
        setIsLoading(true)
        getLeadsCompleted()
          .then(res => {
            setData({
              ...data,
              completed: res.data.data.map(<T,>(item: FetchDataType<T>) => ({
                service: '',
                type: item.type_of_cleaning,
                howFast: item.created_at,
                address: `${item.country}, ${item.city}, ${item.street}`,
                city: item.city,
                zip: '',
                name: item.country,
                phone: '',
                email: '',
              })),
            })
            setIsLoading(false)
          }).catch(() => setIsLoading(false))
        return;

      case 'available':
        setIsLoading(true)
        getLeadsAvailable()
          .then(res => {
            setData({
              ...data,
              available: res.data.data.map(<T,>(item: FetchDataType<T>) => ({
                service: '',
                type: item.type_of_cleaning,
                howFast: item.created_at,
                address: `${item.country}, ${item.city}, ${item.street}`,
                city: item.city,
                zip: '',
                name: item.country,
                phone: '',
                email: '',
              })),
            })
            setIsLoading(false)
          }).catch(() => setIsLoading(false))
        return;
      default: () => false
    }
  }

  const tabs = [
    {
      key: 'newToday',
      title: 'New Today',
      content: <Table items={data.newToday} columns={columns} />,
    },
    {
      key: 'available',
      title: 'Available',
      content: <Table items={data?.available} columns={columns} />,
    },
    {
      key: 'inWork',
      title: 'In Work',
      content: <Table items={data.inWork} columns={columns} />,
    },
    {
      key: 'completed',
      title: 'Completed',
      content: <Table items={data.completed} columns={columns} />,
    },
  ]

  return (
    <Container title="Leads">
      <Tabs defaultActiveKey="newToday" tabs={tabs} onClickTab={onClickTab} isLoading={isLoading} />
    </Container>
  )
}

export default Leads
